import { addImageNotAvailable, buildApiImageUrl } from 'services/product-data.service';
import { DataResult } from 'models/data';
import { MetricsLoadingSpinner } from 'components/MetricsLoadingSpinner';
import { useContext } from 'react';
import { TenantConfigContext } from 'context/TenantConfigContext';
import { EntityHeader } from 'pages/entities/components/EntityHeader';
import { categoryLink, createStyleNameFromAttributes, productLink } from 'pages/entities/entityhelper';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

interface ProductDetailsSummaryProps {
  response: DataResult | null;
}

export function StyleDetailsSummary({ response }: ProductDetailsSummaryProps) {
  const tenantContext = useContext(TenantConfigContext);
  const intl = useIntl();
  const { tab } = useParams();

  if (!response) {
    return <MetricsLoadingSpinner />;
  }

  const articles = response.sets?.articles ?? [];

  const attributes = response.attributes ?? {};
  const imageUrl = articles.find(article => article.attributes?.artImageUrl != null)?.attributes?.artImageUrl ?? '';
  const productName = attributes.prdName ?? '';

  const uniqueSizes = [...new Set(articles.map(a => a.attributes?.artSize))];

  return (
    <EntityHeader
      imageElement={
        <img
          src={buildApiImageUrl(tenantContext.accountNumber, imageUrl)}
          alt={productName}
          onError={addImageNotAvailable}
          className="w-full h-full !bg-snow-50"
        />
      }
      entity={'style'}
      entityDisplayName={createStyleNameFromAttributes(attributes ?? {})}
      boxedAttributes={[
        {
          attributeCode: 'prdCategory',
          attributeValue: attributes.prdCategory,
          link: categoryLink(attributes.prdCategory, tab),
        },
        {
          attributeCode: 'prdNumber',
          label: intl.formatMessage({ id: 'entities.name.singular.product' }),
          attributeValue: attributes.prdNumber,
          link: productLink(attributes.prdNumber ?? '', tab),
        },
        { attributeCode: 'prdNumber', attributeValue: attributes.prdNumber, useRaw: true },
        { attributeCode: 'prdSeason', attributeValue: attributes.prdSeason },
      ]}
      rowAttributes={[
        {
          attributeCode: 'artSize',
          labelId: 'entities.attribute.name.plural.size',
          attributeValues: uniqueSizes,
        },
      ]}
    />
  );
}
